import Vue from 'vue'
import Router from 'vue-router'
import { stringifyQuery, parseQuery } from "./utils/query";
import eHeader from '@/components/header/e_index.vue'
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
export const constantRoutes = [
    {
      path: '/',
      component: () => import('@/views/home/index'),
      alias: '/index',
      hidden: true,
      meta:{title: '首页'},
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import('@/views/home/mobile'),
      meta: { title: '首页'} // 标记该路由需要移动端访问
    },
    {
      path: '/mobile_menu',
      name: 'mobile_menu',
      component: () => import('@/views/home/components/mobile_menu.vue'),
      meta:{title: '移动端菜单'},
    },
    {
      path: '/shopping_cart',
      component: () => import('@/views/composite/shopping_cart/index'),
      hidden: true,
      meta:{title: '购物车'}
    },
    {
      path: '/create_order',
      component: () => import('@/views/composite/shopping_cart/components/create_order.vue'),
      hidden: true,
      meta:{title: '生成订单'}
    },
    // {
    //   path: '/compare',
    //   component: () => import('@/views/composite/compare/index'),
    //   hidden: true,
    //   meta:{title: '产品对比'}
    // },
    {
      path: '/collection',
      component: () => import('@/views/composite/collection/index'),
      hidden: true,
      meta:{title: '我的关注'}
    },
    {
      path: '/hot_services',
      component: () => import('@/views/hot_services/index'),
      hidden: true,
      meta:{title: '热门服务'}
    },
    
    // 企业相关路由
    {
      path: '',
      component: eHeader,
      hidden: false,
      meta:{title: '工厂信息'},
      children:[
        {
          path: '/buyyer_info',
          name: 'buyyer_info',
          component: () => import('@/views/enterprise/enterprise_details/index'),
          hidden: false,
          meta:{title: '采购商信息'},
        },
        {
          path: '/factory_info',
          name: 'factory_info',
          component: () => import('@/views/enterprise/enterprise_details/index'),
          hidden: false,
          meta:{title: '工厂信息'},
        },
        {
          path: '/supplier_info',
          name: 'supplier_info',
          component: () => import('@/views/enterprise/enterprise_details/index'),
          hidden: false,
          meta:{title: '供应商信息'},
        },
        // {
        //   path: '/album',
        //   component: () => import('@/views/enterprise/album/index'),
        //   hidden: false,
        //   meta:{title: '企业相册'},
        // },
        {
          path: '/multimedia',
          name: 'multimedia',
          component: () => import('@/views/enterprise/multimedia/index'),
          hidden: false,
          meta:{title: '多媒体中心'},
        },
        {
          path: '/production',
          name: 'production',
          component: () => import('@/views/enterprise/production/index'),
          hidden: false,
          meta:{title: '生产与工艺'},
        },
        // {
        //   path: '/equipment',
        //   name: 'equipment',
        //   component: () => import('@/views/enterprise/equipment/index'),
        //   hidden: false,
        //   meta:{title: '生产设备'},
        // },
        // {
        //   path: '/detection_equipment',
        //   name: 'detection_equipment',
        //   component: () => import('@/views/enterprise/detection_equipment/index'),
        //   hidden: false,
        //   meta:{title: '检测设备'},
        // },
        {
          path: '/typical_products',
          name: 'typical_products',
          component: () => import('@/views/enterprise/typical_products/index'),
          hidden: false,
          meta:{title: '产品中心'},
        },
        // {
        //   path: '/typical_customers',
        //   name: 'typical_customers',
        //   component: () => import('@/views/enterprise/typical_customers/index'),
        //   hidden: false,
        //   meta:{title: '典型客户'},
        // },
        // {
        //   path: '/qualification',
        //   component: () => import('@/views/enterprise/qualification/index'),
        //   hidden: false,
        //   meta:{title: '资质信息'},
        // },
        // {
        //   path: '/company_profile',
        //   component: () => import('@/views/enterprise/company_profile/index'),
        //   hidden: false,
        //   meta:{title: '工商信息'},
        // },
        // {
        //   path: '/contact_us',
        //   component: () => import('@/views/enterprise/contact_us/index'),
        //   hidden: false,
        //   meta:{title: '联系我们'},
        // }
      ]
    },
    // {
    //   path: '/album',
    //   component: () => import('@/views/enterprise/album/index'),
    //   hidden: true,
    //   meta:{title: '企业相册'}
    // },
    {
      path: '/403',
      component: () => import('@/views/403.vue'),
      hidden: true,
      meta:{title: '没有权限'}
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  stringifyQuery: stringifyQuery, // 序列化query参数
  parseQuery: parseQuery, // 反序列化query参数
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
